import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {DesconsolidationType, GetParams, GetResponse, PostResponse} from '@app/shared';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class DeconsolidationTypeService {
  /** URLs principales relacionadas con Desconsolidation **/
  desconsolidationTypeUrl = environment.coreApiBaseUrl + '/api/deconsolidation-type';
  constructor(private http: HttpClient) { }

  /** Metodos de obtener/crear/actualizar/eliminar Desconsolidation **/
  getDesconsolidationType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.desconsolidationTypeUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createDesconsolidationType(newDesconsolidationType: {name: string, isActive: boolean}): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.desconsolidationTypeUrl, newDesconsolidationType);
  }

  updateDesconsolidationType(desconsolidationType: DesconsolidationType): Observable<any> {
    return this.http.put(this.desconsolidationTypeUrl, desconsolidationType);
  }

  deleteDesconsolidationType(desconsolidationsTypeIds: number[]): Observable<any> {
    return this.http.delete(this.desconsolidationTypeUrl, {body: {ids: desconsolidationsTypeIds}});
  }
}
